import axios from 'axios';

const API_ROOT = `/api/v1/sites`;

export async function getShortUrl(siteId: string, url: string): Promise<string> {
  const path = `${API_ROOT}/${siteId}/url-shortener`;
  const response = await axios.post(path, { url });

  return response.data.short_url;
}
